import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'
import { FormAtylBase } from '../../../../form-atyl-base'


@Component({
	selector: 'atyl-form-input-tel',
	templateUrl: './form-input-tel.component.html',
	styleUrls: ['./form-input-tel.component.scss']
})
export class FormInputTelComponent implements OnInit {

	@Input() forminput: FormAtylBase<any>
	@Input() group: any
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() outline: any
	@Input() disabled: boolean

	@Output() inputTyped = new EventEmitter<any>()
	label: string
	errorString: string

	constructor(
		private readonly inputLabelPipe: InputLabelPipe
	) {

	}
	ngOnInit(): void {
		this.label = this.inputLabelPipe.transform(this.forminput)
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
	}
	customBehaviourHandler(customBehaviour: any) {
		this.inputTyped.emit(customBehaviour)
	}
	log(event: MouseEvent) {
		console.log(event)
	}
	replaceValue(newValue: any) {
		this.group.get(String(this.forminput.ID)).setValue(newValue.value)
	}
	
    onCell1CountryChange(e: any) {
		/*
	    this.cellnumber1DialCode =  e.dialCode;
	    this.cell1TelInput.initialCountry = e.iso2
	    this.cell_code1.setNumber("") 
	    */
	   let v:string="+"+e.dialCode+this.group.get(String(this.forminput.ID)).value
	   this.group.get(String(this.forminput.ID)).setValue(v)
	   
	 //  console.log("onCell1CountryChange",e,this.group.get(String(this.forminput.ID)).value);
  	}
  	
 
  
  

	
}
